import React, { useState } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';
import { Package, Check, AlertTriangle, Users } from 'lucide-react';

// Carte Swipe d'une ligne de commande à réceptionner : droite = conforme, gauche = écart / manquant
const ReceptionSwipeCard = ({ line, index, onSwipeRight, onSwipeLeft, isTop }) => {
  const [exitDir, setExitDir] = useState(null);
  const x = useMotionValue(0);
  const rotate = useTransform(x, [-200, 200], [-15, 15]);
  const okOpacity = useTransform(x, [0, 100], [0, 1]);
  const issueOpacity = useTransform(x, [-100, 0], [1, 0]);

  const handleDragEnd = (_, info) => {
    if (info.offset.x > 100) { setExitDir('right'); onSwipeRight(line, index); }
    else if (info.offset.x < -100) { setExitDir('left'); onSwipeLeft(line, index); }
  };

  return (
    <motion.div
      data-testid={`reception-card-${index}`}
      className={`absolute w-full max-w-md ${isTop ? 'cursor-grab active:cursor-grabbing' : ''}`}
      style={{ x, rotate }}
      drag={isTop ? 'x' : false}
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={0.7}
      onDragEnd={handleDragEnd}
      initial={{ scale: isTop ? 1 : 0.95, y: isTop ? 0 : 10, opacity: isTop ? 1 : 0.7 }}
      animate={{ scale: isTop ? 1 : 0.95, y: isTop ? 0 : 10, opacity: isTop ? 1 : 0.7 }}
      exit={{ x: exitDir === 'right' ? 300 : exitDir === 'left' ? -300 : 0, opacity: 0, transition: { duration: 0.3 } }}
      whileTap={isTop ? { scale: 1.02 } : {}}
    >
      <div className="bg-white border border-gray-200 rounded-3xl shadow-card-stack overflow-hidden">
        <div className="h-3 bg-gradient-to-r from-emerald-400 via-neon-yellow to-emerald-400" />
        <motion.div className="absolute top-6 right-4 bg-emerald-500 text-white px-4 py-2 rounded-full font-bold text-lg transform rotate-12 shadow-lg z-10" style={{ opacity: okOpacity }}>
          CONFORME
        </motion.div>
        <motion.div className="absolute top-6 left-4 bg-red-500 text-white px-4 py-2 rounded-full font-bold text-lg transform -rotate-12 z-10" style={{ opacity: issueOpacity }}>
          ÉCART
        </motion.div>
        <div className="p-6">
          <div className="flex items-center gap-2 mb-3">
            <span className="px-2.5 py-1 rounded-full bg-gray-100 text-gray-600 border border-gray-200 text-xs font-semibold">{line.category || 'Produit'}</span>
            {line.supplier && <span className="px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 border border-amber-200 text-xs font-semibold">{line.supplier}</span>}
          </div>
          <h3 className="font-heading text-2xl font-bold text-gray-900 mb-3" data-testid={`reception-card-name-${index}`}>{line.product_name}</h3>
          <div className="flex items-center gap-3 mb-4">
            <div className="flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full">
              <Package size={16} strokeWidth={2.5} />
              <span className="font-bold text-lg" data-testid={`reception-card-qty-${index}`}>{line.quantity} {line.unit}</span>
            </div>
            <span className="text-sm text-gray-500">commandé</span>
          </div>
          {line.requesters?.length > 0 && (
            <div className="flex items-start gap-1.5 text-xs text-gray-500 mb-4"><Users size={14} className="mt-0.5" /><span>{line.requesters.join(' · ')}</span></div>
          )}
          <div className="flex justify-center gap-8 pt-3 border-t border-gray-100">
            <div className="flex items-center gap-2 text-red-600 font-medium"><AlertTriangle size={20} strokeWidth={3} /><span className="text-sm">Écart</span></div>
            <div className="flex items-center gap-2 text-emerald-600 font-medium"><span className="text-sm">Conforme</span><Check size={20} strokeWidth={3} /></div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ReceptionSwipeCard;
